import { cn } from '../lib/utils';
import { Badge } from './ui/badge';
import { CheckCircle, AlertTriangle, XCircle, MinusCircle } from 'lucide-react';

const statusConfig = {
  on_track: {
    label: 'On Track',
    icon: CheckCircle,
    className: 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800',
  },
  at_risk: {
    label: 'At Risk',
    icon: AlertTriangle,
    className: 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-800',
  },
  over: {
    label: 'Over Budget',
    icon: XCircle,
    className: 'bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800',
  },
  neutral: {
    label: 'No Allocation',
    icon: MinusCircle,
    className: 'bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700',
  },
};

const submissionStatusConfig = {
  DRAFT: {
    label: 'Draft',
    className: 'bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700',
  },
  SUBMITTED: {
    label: 'Submitted',
    className: 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800',
  },
  APPROVED: {
    label: 'Approved',
    className: 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800',
  },
  REJECTED: {
    label: 'Rejected',
    className: 'bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800',
  },
};

export function StatusBadge({ status, showIcon = true }) {
  const config = statusConfig[status] || statusConfig.neutral;
  const Icon = config.icon;

  return (
    <Badge variant="outline" className={cn('gap-1.5 font-medium', config.className)}>
      {showIcon && <Icon className="w-3.5 h-3.5" />}
      {config.label}
    </Badge>
  );
}

export function SubmissionStatusBadge({ status }) {
  const config = submissionStatusConfig[status] || submissionStatusConfig.DRAFT;

  return (
    <Badge variant="outline" className={cn('font-medium', config.className)}>
      {config.label}
    </Badge>
  );
}
